import React from 'react';
import {connect} from 'react-redux'
import {formValueSelector, stopSubmit, reset, clearSubmitErrors, Field} from 'redux-form'
import Paper from 'material-ui/Paper';

import { saveAs } from 'file-saver';
import encoding from 'encoding-japanese';

import * as actions from '../../actions'

import moment from 'moment'

import Loading from '../../components/Loading';
import PageBase from '../../components/PageBase';
import DataTables from '../../components/DataTables/DataTables'
import YosanListForm from './YosanListForm'
import YosanSummaryCsvTable from './YosanSummaryCsvTable'
import styles from '../../styles'
import listHeader from './listHeader'
import {createYosanList} from './createYosanList'

import * as commons from '../../commons';


import $ from 'jquery'
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import * as colors from "material-ui/styles/colors";
import PersonIcon from "material-ui/svg-icons/social/person";

import FormText from '../../components/FormText'

require('es6-promise').polyfill();
require('isomorphic-fetch');
require('whatwg-fetch-timeout');


const validate = (values, kind) => {
  const errors = {}
  const requiredFields = [
  ]
  if (values.summary) {
    requiredFields.push("branchOfficeId")
  }

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })

  if (!values.startDateYear && values.startDateMonth) {
      errors.startDateYear = '年を入力して下さい。'
  }

  if (!values.endDateYear && values.endDateMonth) {
      errors.endDateYear = '年を入力して下さい。'
  }

  if (values.startDate && values.endDate) {
    if (moment(values.startDate).unix() > moment(values.endDate).unix()) {
      errors.startDateYear = '期間が不正です。'
      errors.startDateMonth = '期間が不正です。'
      errors.endDateYear = '期間が不正です。'
      errors.endDateMonth = '期間が不正です。'
    }
  }


  if (kind == 3) {
    if (!values.startDate) {
      errors.startDateYear = '必須入力'
      errors.startDateMonth = '必須入力'
    }
    if (!values.endDate) {
      errors.endDateYear = '必須入力'
      errors.endDateMonth = '必須入力'
    }

    if (!errors.startDateYear
        && !errors.startDateMonth
        && !errors.endDateYear
        && !errors.endDateMonth
    ) {

      const startYear = Number(moment(values.startDate).format("Y"));
      const startMonth = Number(moment(values.startDate).format("M"));
      const endYear = Number(moment(values.endDate).format("Y"));
      const endMonth = Number(moment(values.endDate).format("M"));


      if (startYear == endYear) {
        if (startMonth != 4) {
          errors.startDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.startDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
        }
        if (endMonth != 9) {
          errors.startDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.startDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
        }
      } else {

        const nextYear = startYear + 1

        if (nextYear != endYear) {
          errors.startDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.startDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
        }

        if (startMonth != 10) {
          errors.startDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.startDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
        }

        if (endMonth != 3) {
          errors.startDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.startDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateYear = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
          errors.endDateMonth = '半期の期間で入力して下さい。4月～9月 または 10月～翌年3月'
        }

      }

    }

  }


  if (values.orderAmmount && !commons.validateNumber(values.orderAmmount)) {
    errors.orderAmmount = '数値入力を入力して下さい。'
  }

  if (values.budgetAvg && !commons.validateNumber(values.budgetAvg)) {
    errors.budgetAvg = '数値入力を入力して下さい。'
  }

  if (values.resultAvg && !commons.validateNumber(values.resultAvg)) {
    errors.resultAvg = '数値入力を入力して下さい。'
  }

  return errors
}

const validateSearch = values => {
  const errors = {}
  const requiredFields = [
    "startDate",
    "endDate",
  ]

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })

  if (!values.startDateYear && values.startDateMonth) {
      errors.startDateYear = '年を入力して下さい。'
  }

  if (!values.endDateYear && values.endDateMonth) {
      errors.endDateYear = '年を入力して下さい。'
  }

  if (values.startDate && values.endDate) {
    if (moment(values.startDate).unix() > moment(values.endDate).unix()) {
      errors.startDate = '期間が不正です。'
      errors.endDate = '期間が不正です。'
    }
  }

  return errors
}

class YosanListPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      // page: 1,
      open: false,
      loading: false,
      fileResultOpen: false,
      fileResult: 0,
    }
  }

  componentDidMount() {

    const {
      yosanBack,
      page,
      form,
      handleInit,
      handlePageClick,
      history
    } = this.props

    handleInit(page, form);

    $.ajaxTransport("+binary", function (options, originalOptions, jqXHR) {
      // check for conditions and support for blob / arraybuffer response type
      if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
        return {
          // create new XMLHttpRequest
          send: function (headers, callback) {
            // setup all variables
            var xhr = new XMLHttpRequest(),
              url = options.url,
              type = options.type,
              async = options.async || true,
              // blob or arraybuffer. Default is blob
              dataType = options.responseType || "blob",
              data = options.data || null,
              username = options.username || null,
              password = options.password || null;

            xhr.addEventListener('load', function () {
              var data = {};
              data[options.dataType] = xhr.response;
              // make callback and send data
              callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
            });

            xhr.open(type, url, async, username, password);

            // setup custom headers
            for (var i in headers) {
              xhr.setRequestHeader(i, headers[i]);
            }

            xhr.responseType = dataType;
            xhr.send(data);
          },
          abort: function () {
            jqXHR.abort();
          }
        };
      }
    });

  }

  handleDownloadEnd() {
    this.setState(Object.assign(this.state, { loading: false }));
  }

  handleDownloadStart() {

    this.setState(Object.assign(this.state, { loading: true }));

  }

  handleCsvDownload(start, end, handleFormCheck) {

    return function (values) {

      if (!handleFormCheck(values)) {
        return;
      }

      start()

      values.q = "q"

      if (values.startDate) {
        values.startDate = values.startDate.format('YYYY-MM-DD');
      }
      if (values.endDate) {
        values.endDate = values.endDate.format('YYYY-MM-DD');
      }
      $.ajax({
        url: `/bg/yosan/csv`,
        dataType: "text",
        processData: false,
        data:JSON.stringify(values),
        contentType: 'application/json',
        timeout: 1000 * 100,
        error: function () {
        },
        success: function (data) {

          end()

          const name = '実行予算.csv'

          const unicodeList = [];
          for (let i = 0; i < data.length; i += 1) {
            unicodeList.push(data.charCodeAt(i));
          }

          // 変換処理の実施
          const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
          const uInt8List = new Uint8Array(shiftJisCodeList);

          // csv書き込みの実装
          const writeData = new Blob([uInt8List], { type: 'text/csv' });

          saveAs(writeData, name);

          return;

          // const mimeType = 'text/csv; charset=SHIFT-JIS'
          //
          // let blob = new Blob([data], {type: mimeType})
          // let downloadUrl = URL.createObjectURL(blob);
          //
          // let a = document.createElement("a");
          // a.href = downloadUrl
          // a.download = name
          // // a.target = '_blank'
          //
          // if (window.navigator.msSaveBlob) {
          //   // for IE
          //   window.navigator.msSaveBlob(blob, name)
          // } else if (window.URL && window.URL.createObjectURL) {
          //   // for Firefox
          //   a.href = window.URL.createObjectURL(blob);
          //   document.body.appendChild(a);
          //   a.click();
          //   document.body.removeChild(a);
          // } else if (window.webkitURL && window.webkitURL.createObject) {
          //   // for Chrome
          //   a.href = window.webkitURL.createObjectURL(blob);
          //   a.click();
          // } else {
          //   // for Safari
          //   window.open('data:' + mimeType + ';base64,' + window.Base64.encode(data), '_blank');
          // }

        },
        type: 'POST'
      });

    }

  }

  handleSummaryCsvDownload(start, end, handleFormCheck, handleSummaryCsvResult) {

    return function (values) {

      const newValues = Object.assign({}, values, {summary: true, q: "q"})

      if (!handleFormCheck(newValues)) {
        return;
      }

      if (newValues.startDate) {
        newValues.startDate = newValues.startDate.format('YYYY-MM-DD');
      }
      if (newValues.endDate) {
        newValues.endDate = newValues.endDate.format('YYYY-MM-DD');
      }

      start()

      let url;
      let dataType;
      if (handleSummaryCsvResult) {
        url = '/bg/yosan/summaryCsv'
        dataType = 'text'
      } else {
        url = '/bg/yosan/csv'
        dataType = 'text'
      }

      $.ajax({
        url: url,
        dataType: dataType,
        processData: false,
        data:JSON.stringify(newValues),
        contentType: 'application/json',
        timeout: 1000 * 100,
        error: function () {
        },
        success: function (data) {

          end()

          if (handleSummaryCsvResult) {
            handleSummaryCsvResult(data)
            return
          }

          const name = '実行予算.csv'

          const unicodeList = [];
          for (let i = 0; i < data.length; i += 1) {
            unicodeList.push(data.charCodeAt(i));
          }

          // 変換処理の実施
          const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
          const uInt8List = new Uint8Array(shiftJisCodeList);

          // csv書き込みの実装
          const writeData = new Blob([uInt8List], { type: 'text/csv' });

          saveAs(writeData, name);

          return;

          // const mimeType = 'text/csv; charset=SHIFT-JIS'
          //
          // let blob = new Blob([data], {type: mimeType})
          // let downloadUrl = URL.createObjectURL(blob);
          //
          // let a = document.createElement("a");
          // a.href = downloadUrl
          // a.download = name
          // // a.target = '_blank'
          //
          // if (window.navigator.msSaveBlob) {
          //   // for IE
          //   window.navigator.msSaveBlob(blob, name)
          // } else if (window.URL && window.URL.createObjectURL) {
          //   // for Firefox
          //   a.href = window.URL.createObjectURL(blob);
          //   document.body.appendChild(a);
          //   a.click();
          //   document.body.removeChild(a);
          // } else if (window.webkitURL && window.webkitURL.createObject) {
          //   // for Chrome
          //   a.href = window.webkitURL.createObjectURL(blob);
          //   a.click();
          // } else {
          //   // for Safari
          //   window.open('data:' + mimeType + ';base64,' + window.Base64.encode(data), '_blank');
          // }

        },
        type: 'POST'
      });

    }

  }

  handleUpload(start, end, handleResultOpen) {

    return function (e) {

      const file = e.target.files.item(0)
      e.target.value = ''

      if (!file || !file.name) {
        return;
      }

      const formData = new FormData();
      formData.append('uploadFile', file);

      const {
        handleUploadSuccess,
        handleUploadError,
      } = this.props

      start()

      fetch('/bg/yosan/upload', {
        method: 'POST',
        body: formData,
        timeout: 1000 * 60 * 5,
        credentials: 'include'
      })
          .then(function (response) {
            return response.json()
          })
          .then(function (json) {

            const data = json.detail

            const unicodeList = [];
            for (let i = 0; i < data.length; i += 1) {
              unicodeList.push(data.charCodeAt(i));
            }

            end()

            if (json.result == 'success') {
              // ヘッダ行を除いた処理件数を出力
              handleResultOpen(json.count)
              handleUploadSuccess()
            } else {
              //エラー情報のみCSV出力
              // 変換処理の実施
              const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
              const uInt8List = new Uint8Array(shiftJisCodeList);

              // csv書き込みの実装
              const writeData = new Blob([uInt8List], {type: 'text/csv'});

              saveAs(writeData, file.name + '_取込結果.csv');

              handleUploadError('アップロードに失敗しました。')
            }

            return json

          }).catch(function (e) {
            console.log(e);
            end()
            handleUploadError('ファイルを処理できませんでした。')
          })

      // const newValues = Object.assign({}, values, {summary: true, q: "q"})
      //
      // let url;
      // let dataType;
      // if (handleSummaryCsvResult) {
      //   url = '/bg/yosan/summaryCsv'
      //   dataType = 'text'
      // } else {
      //   url = '/bg/yosan/csv'
      //   dataType = 'text'
      // }
      //
      // $.ajax({
      //   url: '/bg/yosan/upload',
      //   dataType: dataType,
      //   processData: false,
      //   data:JSON.stringify(newValues),
      //   contentType: 'application/json',
      //   timeout: 1000 * 100,
      //   error: function () {
      //   },
      //   success: function (data) {
      //
      //     end()
      //
      //     if (handleSummaryCsvResult) {
      //       handleSummaryCsvResult(data)
      //       return
      //     }
      //
      //     const name = '実行予算.csv'
      //
      //     const unicodeList = [];
      //     for (let i = 0; i < data.length; i += 1) {
      //       unicodeList.push(data.charCodeAt(i));
      //     }
      //
      //     // 変換処理の実施
      //     const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
      //     const uInt8List = new Uint8Array(shiftJisCodeList);
      //
      //     // csv書き込みの実装
      //     const writeData = new Blob([uInt8List], { type: 'text/csv' });
      //
      //     saveAs(writeData, name);
      //
      //     return;
      //
      //   },
      //   type: 'POST'
      // });

    }

  }


  handleRoumuUpload(start, end, handleResultOpen) {

    return function (e) {

      const file = e.target.files.item(0)
      e.target.value = ''

      if (!file || !file.name) {
        return;
      }

      const formData = new FormData();
      formData.append('uploadFile', file);

      const {
        handleUploadSuccess,
        handleUploadError,
      } = this.props

      start()

      fetch('/bg/roumu/upload', {
        method: 'POST',
        body: formData,
        timeout: 1000 * 60 * 5,
        credentials: 'include'
      })
          .then(function (response) {
            return response.json()
          })
          .then(function (json) {

            const data = json.detail

            const unicodeList = [];
            for (let i = 0; i < data.length; i += 1) {
              unicodeList.push(data.charCodeAt(i));
            }

            end()

            if (json.result == 'success') {
              // ヘッダ行を除いた処理件数を出力
              handleResultOpen(json.count)
              handleUploadSuccess()
            } else {
              //エラー情報のみCSV出力
              // 変換処理の実施
              const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
              const uInt8List = new Uint8Array(shiftJisCodeList);

              // csv書き込みの実装
              const writeData = new Blob([uInt8List], {type: 'text/csv'});

              saveAs(writeData, file.name + '_取込結果.csv');

              handleUploadError('アップロードに失敗しました。')
            }

            return json

          }).catch(function (e) {
            console.log(e);
            end()
            handleUploadError('ファイルを処理できませんでした。')
          })

      // const newValues = Object.assign({}, values, {summary: true, q: "q"})
      //
      // let url;
      // let dataType;
      // if (handleSummaryCsvResult) {
      //   url = '/bg/yosan/summaryCsv'
      //   dataType = 'text'
      // } else {
      //   url = '/bg/yosan/csv'
      //   dataType = 'text'
      // }
      //
      // $.ajax({
      //   url: '/bg/yosan/upload',
      //   dataType: dataType,
      //   processData: false,
      //   data:JSON.stringify(newValues),
      //   contentType: 'application/json',
      //   timeout: 1000 * 100,
      //   error: function () {
      //   },
      //   success: function (data) {
      //
      //     end()
      //
      //     if (handleSummaryCsvResult) {
      //       handleSummaryCsvResult(data)
      //       return
      //     }
      //
      //     const name = '実行予算.csv'
      //
      //     const unicodeList = [];
      //     for (let i = 0; i < data.length; i += 1) {
      //       unicodeList.push(data.charCodeAt(i));
      //     }
      //
      //     // 変換処理の実施
      //     const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
      //     const uInt8List = new Uint8Array(shiftJisCodeList);
      //
      //     // csv書き込みの実装
      //     const writeData = new Blob([uInt8List], { type: 'text/csv' });
      //
      //     saveAs(writeData, name);
      //
      //     return;
      //
      //   },
      //   type: 'POST'
      // });

    }

  }
  
  handleReportDownload(start, end, handleFormCheck) {

    return function (values) {

      if (!handleFormCheck(values)) {
        return;
      }

      start()

      values.q = "q"

      $.ajax({
        url: `/bg/yosan2/report`,
        dataType: "binary",
        processData: false,
        data:JSON.stringify(values),
        contentType: 'application/json',
        error: function () {
        },
        success: function (data) {

          end()

          const name = '実行予算.xlsx'
          const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8'

          let blob = new Blob([data], {type: mimeType})
          let downloadUrl = URL.createObjectURL(blob);

          let a = document.createElement("a");
          a.href = downloadUrl
          a.download = name
          // a.target = '_blank'

          if (window.navigator.msSaveBlob) {
            // for IE
            window.navigator.msSaveBlob(blob, name)
          } else if (window.URL && window.URL.createObjectURL) {
            // for Firefox
            a.href = window.URL.createObjectURL(blob);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else if (window.webkitURL && window.webkitURL.createObject) {
            // for Chrome
            a.href = window.webkitURL.createObjectURL(blob);
            a.click();
          } else {
            // for Safari
            window.open('data:' + mimeType + ';base64,' + window.Base64.encode(data), '_blank');
          }

        },
        type: 'POST'
      });

    }

  }


  handlePreviousPageClick(page, form) {
    const prevPage = page - 1
    // this.setState(Object.assign({}, this.state, {
    //   page: prevPage
    // }))
    this.props.handlePageClick(prevPage, form)
  }

  handleNextPageClick(page, form) { 
    const nextPage = page + 1
    // this.setState(Object.assign({}, this.state, {
    //   page: nextPage
    // }))
    this.props.handlePageClick(nextPage, form)
  }

  handleConfirmOpen(id, item) {
    this.setState(Object.assign({}, this.state, {
      id: id,
      item: item,
      open: true
    }))
  };

  handleResultClose() {
    this.setState(Object.assign({}, this.state, {
      fileResultOpen: false,
      fileResult: 0,
    }))
  }

  handleResultOpen(count) {
    this.setState(Object.assign({}, this.state, {
      fileResultOpen: true,
      fileResult: count,
    }))
  }

  render() {

    const {
      auth,
      list, 
      count, 
      form,
      page,
      selectData,
      selectedBranchOfficeId,
      handleSearchClick,
      handleFormClear,
      handleFormReportCheck,
      handleFormCsvCheck,
      handleFormUpload,
      errorMessage,
      handleErrorDialogClose,
        summaryCsv,
        summaryCsvOpen,
      handleSummaryCsvResult,
      handleSummaryCsvClose,

      startDateYear,
      startDateMonth,
      endDateYear,
      endDateMonth

    } = this.props

    const startDate = dateConvert(startDateYear, startDateMonth)
    const endDate = dateConvert(endDateYear, endDateMonth)

    const dataList = list ? list.map((x, index) => {
      return (createYosanList(x, startDate, endDate))
    }) : []

    return (
      <PageBase title="実行予算一覧" >

        <div>

          <div style={styles.searchBoxContainer}>

            <Paper style={styles.contentsPaper}>

              <YosanListForm
                  auth={auth}
                kenmeiData={selectData.kenmei}
                branchOfficeData={selectData.branchOffice}
                departmentData={selectData.department}
                customerData={selectData.customer}
                constructionData={selectData.construction}
                selectedBranchOfficeId={selectedBranchOfficeId}
                onSearchClick={handleSearchClick}
                onFormClear={handleFormClear}
                onFormUpload={this.handleUpload(this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), this.handleResultOpen.bind(this)).bind(this)}
                onRoumuUpload={this.handleRoumuUpload(this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), this.handleResultOpen.bind(this)).bind(this)}
                initialValues={form}
                onCsvDownload={this.handleCsvDownload(this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), handleFormCsvCheck).bind(this)}
                onSummaryCsvDownload={this.handleSummaryCsvDownload(this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), handleFormCsvCheck).bind(this)}
                onSummaryCsvDisplay={this.handleSummaryCsvDownload(this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), handleFormCsvCheck, handleSummaryCsvResult).bind(this)}
                onReportDownload={this.handleReportDownload(this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), handleFormReportCheck).bind(this)}
              />

            </Paper>

          </div>

          <Paper style={{...styles.contentsPaper}}>
            <DataTables
              tableStyle={{overflow: 'hidden', tableLayout: ''}}
              tableBodyStyle={{overflowX: 'auto'}}
              height={'auto'}
              showRowHover={true}
              columns={listHeader}
              data={dataList}
              page={page}
              showRowSizeControls={false}
              onNextPageClick={this.handleNextPageClick.bind(this, page, form)}
              onPreviousPageClick={this.handlePreviousPageClick.bind(this, page, form)}
              count={count}
            />
          </Paper>

        </div>
        <Loading open={this.state.loading}/>

          <Dialog
              title="アップロードエラー"
              modal={true}
              open={errorMessage ? true : false}
              autoScrollBodyContent={true}
              actions={[
                  <FlatButton
                      label="閉じる"
                      primary={true}
                      labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                      style={{ height: '40px', width: '120px', marginRight: '20px' }}
                      onTouchTap={handleErrorDialogClose}
                  />
              ]}
          >
              { errorMessage && errorMessage.map((x, i) => (<p key={i}>{x}</p>)) }

          </Dialog>

        <Dialog
            title="取込件数"
            modal={true}
            // style={{width: '50%'}}
            open={this.state.fileResultOpen ? true : false}
            autoScrollBodyContent={true}
            actions={[
              <FlatButton
                  label="閉じる"
                  primary={true}
                  labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                  style={{ height: '40px', width: '120px', marginRight: '20px' }}
                  onTouchTap={this.handleResultClose.bind(this)}
              />
            ]}
        >
          <span style={{...styles.title, marginRight: 10}}>
            { this.state.fileResult }
          </span>
          件を取込ました。
        </Dialog>

        <Dialog
            title="合計出力"
            modal={true}
            open={summaryCsvOpen}
            autoScrollBodyContent={true}
            actions={[
              <FlatButton
                  label="閉じる"
                  primary={true}
                  labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                  style={{ height: '40px', width: '120px', marginRight: '20px' }}
                  onTouchTap={handleSummaryCsvClose}
              />
            ]}
        >
          <YosanSummaryCsvTable summaryCsv={summaryCsv}/>
          {/*{ summaryCsv }*/}
        </Dialog>

      </PageBase>
    );

  }

}


const selector = formValueSelector('yosanListForm')
const mapStateToProps = (state) => ({
  auth: state.auth,
  yosanBack: state.yosan.transition,
  list: state.yosanList.list,
  count: state.yosanList.count,
  form: state.yosanList.form,
  page: state.yosanList.page,
  summaryCsv: state.yosanList.summaryCsv,
  summaryCsvOpen: state.yosanList.summaryCsvOpen,
  selectData: state.yosanList.selectData,
  selectedBranchOfficeId: selector(state, 'branchOfficeId'),
  startDateYear: selector(state, 'startDateYear'),
  startDateMonth: selector(state, 'startDateMonth'),
  endDateYear: selector(state, 'endDateYear'),
  endDateMonth: selector(state, 'endDateMonth'),
  errorMessage: state.global.errorMessage,
})

const dateConvert = (year, month) => {

  if (!year) {
    return
  }

  if (!month) {
    return moment().year(year).month(0).date(1)
  }

  return moment().year(year).month(month - 1).date(1)

}

const mapStateToDispatch = (dispatch) => ({
  handleInit : (page, form) => {dispatch(actions.systemYosanListInit(page, form))},
  handleSearchClick : (orderAmmountGrLe, budgetGrLe, resultGrLe, report) => (values) => {

      const startDate = dateConvert(values.startDateYear, values.startDateMonth)
      const endDate = dateConvert(values.endDateYear, values.endDateMonth)

      values.startDate = startDate
      values.endDate = endDate

    if (report && report == 1) {
      const errors = validateSearch(values)
      if (Object.keys(errors).length) {
        dispatch(stopSubmit(`yosanListForm`, errors))
        return
      }
    } else {
      const errors = validate(values)
      if (Object.keys(errors).length) {
        dispatch(stopSubmit(`yosanListForm`, errors))
        return
      }
    }

    const newValues = Object.assign({}, values, {orderAmmountGrLe, budgetGrLe, resultGrLe})
    dispatch(actions.userYosanListSearch(1, newValues, report))
  },
  handlePageClick : (page, form) => {
    dispatch(actions.userYosanListSearch(page, form))
  },
  handleFormClear : () => {
    dispatch(actions.reducerYosanListFormClear())
  },
  handleFormReportCheck : (values) => {

    const startDate = dateConvert(values.startDateYear, values.startDateMonth)
    const endDate = dateConvert(values.endDateYear, values.endDateMonth)

    values.startDate = startDate
    values.endDate = endDate

    const errors = validate(values, 3)

    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`yosanListForm`, errors));
      return false
    }

    dispatch(clearSubmitErrors(`yosanListForm`));

    return true

  },

  handleSummaryCsvResult : (data) => {

    dispatch(actions.reducerSummaryCsvResult(data))

    return true

  },

  handleSummaryCsvClose : () => {

    dispatch(actions.reducerSummaryCsvClose())

    return true

  },

  handleFormCsvCheck : (values) => {

    const startDate = dateConvert(values.startDateYear, values.startDateMonth)
    const endDate = dateConvert(values.endDateYear, values.endDateMonth)

    values.startDate = startDate
    values.endDate = endDate

    const errors = validate(values)

    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`yosanListForm`, errors));
      return false
    }

    dispatch(clearSubmitErrors(`yosanListForm`));

    return true

  },

    handleFormUpload : (e) => {
        dispatch(actions.userYosanListUpload(e.target.files.item(0)))
        e.target.value = null;
    },

    handleErrorDialogClose : () => {
        dispatch(actions.reducerErrorMessage(null))
    },


  handleUploadSuccess : () => {
    dispatch(actions.reducerSnackBar(true, 'アップロードが完了しました。', colors.green400))
  },

  handleUploadError : (message) => {
    dispatch(actions.reducerSnackBar(true, message, colors.red400))
  },

})

YosanListPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(YosanListPage)

export default YosanListPage;



// WEBPACK FOOTER //
// ./src/containers/yosan/YosanListPage.js